module.exports = __webpack_public_path__ + "85d8a0c8386a512a6056c66f2811cade.svg";